import { Link } from 'react-router-dom';

import bannerCraftImage from "../../../../images/optimized/craftStoreCropped.webp";
import { useAuth } from '../../../../context/AuthContext';

interface HomeBannerProps {
  message?: boolean;
}

export const HomeBanner = ({ message }: HomeBannerProps) => {
  const { isAuthenticated, signIn } = useAuth();
  console.log('message', message);
  
  const handleCreateClick = (e: React.MouseEvent) => {
    if (!isAuthenticated && signIn) {
      e.preventDefault();
      signIn();
    }
  };
  return (
    <section
      style={{
        width: '100vw',
        minWidth: '100vw',
        height: 350, // main banner height
        position: 'relative',
        margin: 0,
        padding: 0,
        overflow: 'visible',
        background: `linear-gradient(180deg, rgb(251, 232, 198) 0%, rgb(251, 232, 198) 70%, rgb(247, 249, 250) 100%)`,
        borderRadius: 0,
        zIndex: 1,
      }}
    >
      {/* Craft store row - 1.5x taller */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100vw',
          height: 210, // 1.5x the original (140px * 1.5)
          background: `url(${bannerCraftImage}) repeat-x center top`,
          backgroundSize: 'auto 210px',
          zIndex: 0,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
        aria-hidden="true"
      />

      {/* Floating Welcome Box - ABSOLUTE, overlaps below section */}
      {message && (
        <div
          style={{
            position: 'absolute',
            left: '50%',
            bottom: -30, // pulls it down to overlap the next section (adjust as needed)
            transform: 'translateX(-50%)',
            width: 900,
            maxWidth: '94vw',
            minWidth: 240,
            padding: '38px 36px 34px 36px',
            background: '#355D7A',
            boxShadow: 'var(--shadow-strong)',
            borderRadius: 24,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 3,
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: '2.8rem',
              fontWeight: 500,
              color: '#F5F7F9',
              letterSpacing: '-1px',
              textAlign: 'center',
              lineHeight: 1.17,
              fontFamily: 'Georgia, serif',
            }}
          >
            Welcome to Free Pattern Warehouse
          </h1>
          <p
            style={{
              fontSize: '1.26rem',
              color: '#F5F7F9',
              margin: '30px 0 28px 0',
              fontWeight: 500,
              textAlign: 'center',
              lineHeight: 1.42,
              fontFamily: 'Georgia, serif',
            }}
          >
            Discover, share, and create your next favorite craft project!
            <br />
            Browse free sewing, knitting, beadwork, and felt patterns from makers worldwide.
          </p>
          <Link
            to={isAuthenticated ? "/create" : "#"}
            onClick={handleCreateClick}
            style={{
              display: 'inline-block',
              padding: '14px 48px',
              background: '#F5F7F9',
              color: 'var(--navy-700)',
              borderRadius: 8,
              fontWeight: 700,
              fontSize: '1.14rem',
              textDecoration: 'none',
              letterSpacing: '0.02em',
              boxShadow: 'var(--shadow-soft)',
              transition: 'background 0.13s',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#D6E1E9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#F5F7F9';
            }}
          >
            {isAuthenticated ? 'Create Pattern' : 'Sign In to Create'}
          </Link>
        </div>
      )}
    </section>
  );
}
